
import { computed, reactive, toRefs } from "vue";
import { useStore } from "vuex";

export default {
  components: {},
  setup() {
    const store = useStore();
    const data = reactive({});
    const personInfo = computed(() => store.getters.getSimpleInfo);
    const personImg = computed(() => store.getters.getPersonImg);

    const jumpIndex = () => {
      window.open("https://staff.risfond.com/");
    };
    return {
      ...toRefs(data),
      personInfo,
      jumpIndex,
      personImg,
    };
  },
};
